
<template>
    <div class="vheight comprehensiveList">
        <div class="container-boot" style="padding-right: 10px;padding-left: 10px;">
            <div class="panel-title" >
                <div class="panel-type"  :class="{ active: objType == 1 }" @click="handleTitle(1)">
                    <div class="icon">
                        <i class="el-icon-office-building"></i>
                    </div>
                    <span class="title">物业企业</span>
                </div>
                <div class="panel-type" :class="{ active: objType == 2  }" @click="handleTitle(2)">
                    <div class="icon">
                        <i class="el-icon-user"></i>
                    </div>
                    <span class="title">项目负责人</span>
                </div>
                <div class="panel-type" :class="{ active: objType == 3  }" @click="handleTitle(3)">
                    <div class="icon">
                        <i class="el-icon-set-up"></i>
                    </div>
                    <span class="title">业委会成员</span>
                </div>
                <!-- <div class="panel-type" :class="{ active: objType == 4  }" @click="handleTitle(4)">
                    <div class="icon">
                        <i class="el-icon-coffee"></i>
                    </div>
                    <span class="title">业主</span>
                </div> -->
                <div class="panel-type" :class="{ active: objType == 5  }"  @click="handleTitle(5)">
                    <div class="icon">
                        <i class="el-icon-coffee"></i>
                    </div>
                    <span class="title">业委会执行秘书</span>
                </div>
              <div class="panel-type" :class="{ active: objType == 6  }"  @click="handleTitle(6)">
                <div class="icon">
                  <i class="el-icon-coffee"></i>
                </div>
                <span class="title">业主监事（会）</span>
              </div>
            </div>
            <div class="components-box">
                <template v-if="columnLabel == '通知公告响应率'">
                    <notice-details-list
                      :eaAreaCode='eaAreaCode'
                      :columnLabel='columnLabel'
                      :nickName='nickName'
                    ></notice-details-list>
                </template>
                <template v-else-if="columnLabel == '安全检查情况'">
                    <safety-information-details
                      :columnLabel='columnLabel'
                      :eaAreaCode='eaAreaCode'
                      :objType='objType'
                    ></safety-information-details>
                </template>
                <template v-else-if="columnLabel == '信息公开率'">
                    <information-open-details
                      :columnLabel='columnLabel'
                      :eaAreaCode='eaAreaCode'
                      :objType='objType'
                      :numBool='numBool'
                    ></information-open-details>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import noticeDetailsList from './comprehensiveDetailsComponents/noticeDetailsList';
import safetyInformationDetails from './comprehensiveDetailsComponents/safetyInformationDetails';
import informationOpenDetails from './comprehensiveDetailsComponents/informationOpenDetails';
export default {
    components: {
        noticeDetailsList,
        safetyInformationDetails,
        informationOpenDetails
    },
    props: {},
    data() {
        return {
            objType: 1,
            // infoType: '1',
            columnLabel: '',
            code: '',
            eaAreaCode: '',
            nickName: '',
            numBool: false
        };
    },
    created() {
        this.objType = Number(this.$route.query.objType);
        // this.infoType = this.$route.query.infoType;
        this.code = this.$route.query.code;
        this.columnLabel = decodeURIComponent(this.$route.query.columnLabel);
        this.eaAreaCode = this.$route.query.eaAreaCode || '';
        this.nickName = decodeURIComponent(this.$route.query.nickName || '');
        this.numBool = this.$route.query.numBool || '';
    },
    mounted() {

    },
    methods: {
        handleTitle(val) {
            this.objType = val;
            this.$router.push({name: 'InformationManager', query:{objType: this.objType}});
        },
    }
};
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
.comprehensiveList {
  // .el-tabs__content {
  //   padding: 0px;
  // }
}
</style>
<style lang="scss" scoped>
.comprehensiveList {
  width: 100%;
  box-sizing: border-box;
  .panel-title {
    display: flex;
    justify-content: space-between;
    .active {
      color: rgb(140,78,127)
    }
    .panel-type {
      width: 18%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: whitesmoke;
      .icon {
        font-size: 25px;
        padding-right: 10px;
      }
      .title {
        font-weight: bold;
      }
    }
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    height: 550px;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100% - 150px);
      .el-table {
        height: 100%;
        overflow: auto;
      }
    }
    .components-box{

    }
  }
}
</style>
